// Code block language: what a code block's language control writes. Donor: the Lexical view's
// CodeHighlightingControlsPlugin language change (`text` is no language), which reads this rule.
import { setBlockProps } from './ops'
import type { CoreState } from './state'
import { rows } from './tree-read'

/** The `lang` a code block takes for control value `language`: none for plain `text`. */
export function codeLanguageProp(language: string): string | undefined {
  return language === 'text' ? undefined : language
}

/** Sets code block `blockId`'s language from control value `language`; false when no code block has that id. */
export function setCodeLanguage(state: CoreState, blockId: string, language: string): boolean {
  const code = rows(state.blocks).find((row) => row.block.id === blockId && row.block.type === 'pre')?.block
  if (!code) return false
  setBlockProps(state, code, { lang: codeLanguageProp(language) })
  return true
}
